// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyAHs6A_IRPlobkDef2RhDjDhNsxgaHh940",
    authDomain: "farejando-shop.firebaseapp.com",
    projectId: "farejando-shop",
    storageBucket: "farejando-shop.firebasestorage.app",
    messagingSenderId: "856444149987",
    appId: "1:856444149987:web:7a99c22d6109b2498065d6",
    measurementId: "G-MTBWX4JNXR"
  };

// Inicializa o Firebase
const app = initializeApp(firebaseConfig);

// Inicializa o Firestore (banco de dados)
const db = getFirestore(app);

// Inicializa o Auth (autenticação)
const auth = getAuth(app);



export { db, auth };